var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 958,
    viewBox: "0 0 1437 958",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_920_278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 0,
    width: 1440,
    height: 958
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3 0H1437V879.5H747.572C735.163 879.5 723.06 883.347 712.928 890.513L633.072 946.987C622.94 954.153 610.837 958 598.428 958H-3V0Z",
    fill: "#0B162600"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_920_278)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 1434,
    height: 958,
    fill: "white",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.2b916b63450170431e15708dc00bd5a5.svg";
export { ForwardRef as ReactComponent };